module.exports = __webpack_public_path__ + "static/media/ios.420f06a5.png";